import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { needToRedirectBackToVisitorPage } from './needToRedirectBackToVisitorPage';
import {
  isLoggedInUser,
  promptLoginPage,
} from '../../../contexts/User/helpers/userContextHelpers';
import { getParticipantOrderId } from '../../../selectors/participants';
import { renderSeoMetatagsPage } from '../../../services/SeoMetatagsPage';
import { needToRedirectToLogin } from './needToRedirectToLogin';
import {
  addOnLoginHandler,
  IOnLoginHandlerPriority,
} from '../../../contexts/GeneralDataProvider/helpers/onLogin';

import { getInitialProps } from './getInitialProps';
import { getChallengeData } from '../../../contexts/storage-contexts/Challenge';
import { goToVisitorPage } from './goToVisitorPage';
import { createOrderOrSendJoinRequest } from './createOrderOrSendJoinRequest';

export const createParticipantFlow = async ({
  flowAPI,
}: {
  flowAPI: ControllerFlowAPI;
}) => {
  addOnLoginHandler({
    priority: IOnLoginHandlerPriority.SECONDARY,
    handler: async (flowAPI: ControllerFlowAPI) => {
      const challengeData = await getChallengeData(flowAPI);
      createOrderOrSendJoinRequest({
        initialProps: { challengeData },
        flowAPI,
      });
    },
  });

  const initialProps = await getInitialProps(flowAPI);

  // not logged in, private program
  // go login to see if already purchased
  if (needToRedirectToLogin({ initialProps, flowAPI })) {
    flowAPI.controllerConfig.setProps({
      isForcedBlankPage: true,
    });
    promptLoginPage(flowAPI)
      .then(async () => {
        // send BI?
      })
      .catch(async () => {
        // user closed the login popup - redirect to visitor page
        goToVisitorPage({
          challengeData: initialProps.challengeData,
          flowAPI,
        });
      });
    return;
  }

  // logged in, private program, waiting for owners approval
  if (
    needToRedirectBackToVisitorPage({ initialProps, flowAPI }) &&
    flowAPI.environment.isViewer
  ) {
    flowAPI.controllerConfig.setProps({
      isForcedBlankPage: true,
    });

    goToVisitorPage({
      challengeData: initialProps.challengeData,
      flowAPI,
    });
    return;
  }

  // logged in, public / private & approved, not purchased yet
  if (
    isLoggedInUser(flowAPI) &&
    !getParticipantOrderId(initialProps?.participant) &&
    flowAPI.environment.isViewer
  ) {
    createOrderOrSendJoinRequest({
      initialProps,
      flowAPI,
    });
  } else {
    flowAPI.controllerConfig.setProps({ ...initialProps });
  }

  renderSeoMetatagsPage(
    flowAPI,
    initialProps?.challengeData?.challenge,
    'PAYMENT_PAGE',
  );
};
